import { useEffect, useState } from 'react';

// Interim stand-in until the provisioning status service ships: with no status URL to
// poll, treat the build as done after a fixed wait, so the card holds its "setting up"
// state instead of offering an Open link while the real build is most likely still
// running. Five minutes because the wait covers more than the infrastructure build
// (~1-3 min): Guardian then starts up behind it — database migrations, containers —
// before it is actually usable. Delete this file and its use in EnterpriseHub once
// registerProvisioningStatusUrl gains the real endpoint.
export const INTERIM_READY_MS = 300_000;

export function useInterimReady(key: string | null, startedAt?: number, ms = INTERIM_READY_MS): boolean {
  // Only the fired outcome is stored, keyed by what was being waited on, so a changed
  // key starts a fresh wait without any render-time state writes.
  const [done, setDone] = useState<{ key: string } | null>(null);

  useEffect(() => {
    if (!key) return;
    // A rehydrated watch resumes mid-wait: only the remaining time is waited, so a
    // reload at minute three rejoins at minute three, not minute zero. Elapsed is
    // clamped at zero so a clock that moved backwards can never stretch the wait
    // beyond the full window.
    const elapsed = Math.max(0, Date.now() - (startedAt ?? Date.now()));
    const remaining = Math.max(0, ms - elapsed);
    const timer = setTimeout(() => setDone({ key }), remaining);
    return () => clearTimeout(timer);
  }, [key, startedAt, ms]);

  return done?.key === key;
}
